interface Environment {
  gqlEndpoint: string;
  gqlEndpointWebSocket: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
}

// console.log(
//   "process.env.REACT_APP_GQL_ENDPOINT:",
//   process.env.REACT_APP_GQL_ENDPOINT
// );

// console.log(
//   "process.env.REACT_APP_FIREBASE_CONFIG:",
//   process.env.REACT_APP_FIREBASE_CONFIG
// );

// Validate required environment variables
if (!process.env.REACT_APP_GQL_ENDPOINT) {
  throw new Error("REACT_APP_GQL_ENDPOINT is not defined");
}

if (!process.env.REACT_APP_GQL_ENDPOINT_WS) {
  throw new Error("REACT_APP_GQL_ENDPOINT_WS is not defined");
}

if (!process.env.REACT_APP_FIREBASE_CONFIG) {
  throw new Error("REACT_APP_FIREBASE_CONFIG is not defined");
}

// Parse Firebase config
const parsedFirebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);

// Create environment config
export const environment: Environment = {
  gqlEndpoint: process.env.REACT_APP_GQL_ENDPOINT,
  gqlEndpointWebSocket: process.env.REACT_APP_GQL_ENDPOINT_WS,
  firebaseConfig: parsedFirebaseConfig,
};

// Environment detection based on GQL endpoint or other environment variables
export const isDevelopment = environment.gqlEndpoint.includes("localhost");
export const isStaging = environment.gqlEndpoint.includes("staging");
export const isProduction = environment.gqlEndpoint.includes("production");
